import axiosDefaults from 'axios/lib/defaults';

export default () => {
    axiosDefaults.withCredentials = true;
};



// WEBPACK FOOTER //
// /src/js/App/appConfig.js